import React, { Fragment, memo, useEffect, useMemo, useRef, useState } from "react";
import {  useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import "./index.scss";
import Spotlight from "../../component/Spotlight";
import Header from "../../component/Header";
import ListContainer from "../../component/ListContainer";
import { CONFIG } from "../../config/constant";
import { setContentListData, setSearchListData, setSearchListEmpty, setSelectedContent } from "../../module/content/content.action";

const Home = memo(function (props) {
  const params = useParams();
  const dispatch = useDispatch();
  const searchQuery = useRef('');
  const [defaultLanguage, setDefaultLanguage] = useState('en');
  const { token } = useSelector((state) => state.auth);
  const { contentDetail, contents, searchList } = useSelector((state) => state.content);
  const { selectedMenu, list } = useSelector((state) => state.menu);
  useEffect(() => {
    if (localStorage.getItem('language')) {
      setDefaultLanguage(localStorage.getItem('language'));
    }
  }, []);
  useEffect(() => {
    if (params?.id || selectedMenu?._id) {
      getContentList(params.id || selectedMenu?._id);
    }
  }, [params?.id, selectedMenu]);

  const showPageMessage = useMemo(() => {
    if (searchQuery?.current) {
      if (searchList?.length) {
        return '';
      } else {
        dispatch(setSelectedContent(null));
        return 'No Results for Your Search';
      }
    }
    if (contents?.length) {
      return '';
    }
  }, [contents, searchList, searchQuery?.current]);
  async function getContentList(id) {
    const url = CONFIG.BASE_URL + `app/content/category/${id}?platform=web`;
    let response = await fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
        "Authorization": token
      },
    });
    if (response && response.status === 200) {
      response = await response.json();
      dispatch(setContentListData(response));
    } else {
      response = await response.json();
    }
  }

  const searchContent = async (query) => {
    searchQuery.current = query;
    if (!query) {
      return;
    }
    const url = CONFIG.BASE_URL + `app/search?language=${defaultLanguage}&query=${query}&platform=web`;
    let response = await fetch(url, {
      method: "GET",
      mode: "cors",
      cache: "no-cache",
      headers: {
        "Content-Type": "application/json",
        "Authorization": token
      },
    });
    if (response && response.status === 200) {
      response = await response.json();
      dispatch(setSearchListData(response));
    }
  };

  const searchClose = () => {
    dispatch(setSearchListEmpty());
  }

  return (
    <Fragment>

      <div className="page-container" style={{
        backgroundImage: `URL('${contentDetail?.thumbnail}')`, 
        backgroundRepeat: 'no-repeat',
        backgroundSize: "cover",
        backgroundPosition: "center"
      }}>
        <Header searchContent={searchContent} searchClose={searchClose} />
        {!showPageMessage ? (<Fragment>
          {contentDetail ? <Spotlight /> : null}
          {list?.length ? <ListContainer /> : null}
        </Fragment>) : (
          <div className="page-container center"><div className="no-data-message">{showPageMessage}</div></div>
        )}
        <div className="page-footer">
             <div className="privacy-terms">
                <span onClick={() => { window.open('https://watchcredo.com/privacy-policy/', "_blank"); }}>Privacy Policy</span>
                <span>|</span>
                <span onClick={() => { window.open('https://watchcredo.com/terms-of-service/', "_blank"); }}>Terms of use</span>
              </div>
        </div>
      </div>
    </Fragment>
  );
});


export default Home;
